<template lang="html">
  <ul class="user-menu d-lg-block d-none">
    <li class="profile">
      <a href="#">
        <LetterAvatar v-if="user" class="profile-picture" :initials="user.initials()"></LetterAvatar>
        <span v-if="user && user.role">{{user.lastname}} {{user.firstname}}<br/>
        ({{user.role.libelle}})</span>
      </a>
      <ul class="profile-menu">
        <li v-for="(menu, index) in userProfileMenu" :key="index">
          <a :href="menu.href"><icon :name="menu.icon" v-if="menu.icon" />{{menu.label}}</a>
        </li>
        <li>
          <a href="#" v-on:click.prevent.stop="logout" ><icon name="power_settings_new"/>Logout</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { USER_LOGOUT } from '@/store/actions/user'
import LetterAvatar from '@/components/LetterAvatar'

export default {
  name: 'UserMenu',
  components: {
    LetterAvatar
  },
  methods: {
    ...mapActions([USER_LOGOUT]),
    async logout () {
      this.USER_LOGOUT()
      await this.$auth.signOut()
    }
  },
  computed: {
    ...mapGetters(['user', 'userProfileMenu'])
  }
}
</script>

<style lang="sass" scoped>
@import './static/sass/variables.sass'
a:hover
  color: $white !important
  text-decoration: unset !important
.user-menu
  float: right
  background-color: $blue-dark
  list-style: none
  font-size: 0.875rem
  padding: 0px 0rem 0 0
  margin: 0
  border-bottom: 0px solid $blue-dark
  display: inline-flex
  align-items: center
  position: relative

  &>li
    position: relative
    padding: 0.5rem

    &:last-child
      margin-right: 0

  .material-icons
    font-size: 1.875rem
    color: rgba($white, 0.5)
    transition: color 0.2s

  li[data-count]:after
    content: attr(data-count)
    position: absolute
    right: 9px
    top: 9px
    background-color: $white
    border-radius: 50%
    padding: 0.15rem
    min-width: 0.6875rem
    min-height: 0.6875rem
    font-size: 0.625rem
    font-weight: 900
    color: $blue-dark
    text-align: center
    border: 3px solid $blue-dark
    box-sizing: unset !important // Résolution du confit entre ~normalize.css/normalize.css , ./node_modules/bootstrap/dist/css/bootstrap.min.css et le template ExoSkill


  .profile
    font-weight: bold
    z-index: 2

    a
      display: inline-flex
      align-items: center

    &>a:after
      content: "\e5c5"
      font-family: $font-icon
      padding-left: 0.8rem
      opacity: 0.5
      font-size: 1.5rem

    &:hover
      background-color: $blue-menu
      .profile-menu
        display: block
        opacity: 1

  .profile-picture
    margin-right: 1rem
    display: inline-block


  .profile-menu
    display: none
    background-color: $blue-menu
    position: absolute
    width: 100%
    left: 0
    top: 100%
    padding: 0
    text-transform: uppercase
    font-size: 0.75rem
    font-weight: bold
    color: $white
    letter-spacing: 1px
    z-index: 1
    opacity: 0
    box-shadow: 0 8px 9px 0 rgba($black, 0.2)
    transition: opacity 0.5s 3s
    text-align: left

    li
      display: inline-block
      width: 100%

    .material-icons
      fill: $white
      color: $white
      font-size: 1.5rem
      padding-right: 1rem
      padding-left: 1.5rem

    a
      padding: 1rem 0
      display: inline-block
      color: rgba($white, 0.6)
      transition: color 0.2s

      &:hover
        color: $white
</style>



// WEBPACK FOOTER //
// src/components/menu/UserMenu.vue